import { DatePicker } from "@material-ui/pickers";
import {
  AutocompleteArrayInput,
  FormDataConsumer,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectInput,
  useAuthenticated,
} from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import resourceNames from "../../../common/data/resourceNames";
import { useSearchFields } from "../../../common/hooks/useSearchFields";

interface Props extends RouteComponentProps {}

export const VehicleDistanceReport = (props: Props) => {
  useAuthenticated();
  useSearchFields(props, ["name"], resourceNames.ADMIN_VEHICLES);

  return (
    <ReportForm
      reportName="vehicle-distance-report"
      {...props}
      title="resources.reports.vehicleDistance.name"
      submitMethod={(x) => x.reportVehicledistancereportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <ReferenceInput
        reference={resourceNames.ADMIN_COMPANIES}
        validate={required()}
        source="companyId"
      >
        <SelectInput />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          return (
            formData["companyId"] && (
              <ReferenceArrayInput
                reference={resourceNames.ADMIN_VEHICLES}
                source="vehicles"
                filter={{ companyId: formData["companyId"] }}
                {...rest}
              >
                <AutocompleteArrayInput />
              </ReferenceArrayInput>
            )
          );
        }}
      </FormDataConsumer>
    </ReportForm>
  );
};
